module.exports = __webpack_public_path__ + "img/urleditor.b9086d5a.svg";